/* global regionsLookup */

import mapboxgl from 'mapbox-gl';

mapboxgl.accessToken =
    'pk.eyJ1IjoiY29yYWxjb2FzdCIsImEiOiJjbGFtNGJxN3cwOGRoM3NwZng0MGNzdGpkIn0.jauhTNc6SeIwit2ZJZkmVg';

const maps = Array.from(document.querySelectorAll('.region-map__map'));
let hoveredRegion = '';

if (maps.length) {
    const map = new mapboxgl.Map({
        container: 'region-map__map',
        style: 'mapbox://styles/coralcoast/clbxq0x8m000j14nytr5vgi1p',
        center: [115, -27], // starting position [lng, lat]
        zoom: 5.5, // starting zoom
        minZoom: 3,
        maxZoom: 10,
        cooperativeGestures: true,
        projection: 'mercator',
        dragRotate: false,
        pitchWithRotate: false,
        touchZoomRotate: false
    });
    map.addControl(new mapboxgl.NavigationControl(), 'bottom-right');
    map.on('load', function () {
        map.addLayer({
            id: 'region-layer-labels',
            type: 'circle',
            source: 'composite',
            'source-layer': 'acc_poi',
            filter: ['match', ['get', 'type'], ['region'], true, false],
            paint: {
                'circle-opacity': 0
            }
        });

        map.on('idle', function () {
            visualiseRegionMarkers();
        });

        map.on('moveend', () => {
            visualiseRegionMarkers();
        });

        let regionMarkers = [];
        function visualiseRegionMarkers() {
            let features = map.queryRenderedFeatures({ layers: ['region-layer-labels'] });
            features = getUniqueFeatures(features, 'fid');

            regionMarkers.forEach((marker) => {
                marker.remove();
            });
            regionMarkers = [];

            features.forEach((feature) => {
                const el = createRegionLabel(
                    feature.properties.name,
                    feature.properties.color,
                    map.getZoom()
                );
                let marker = new mapboxgl.Marker({
                    element: el,
                    anchor: feature.properties['label-position'] == 'right' ? 'left' : 'right'
                })
                    .setLngLat(feature.geometry.coordinates)
                    .addTo(map);
                regionMarkers.push(marker);
            });
        }

        map.setLayoutProperty('acc-region-point', 'visibility', 'none');

        function createRegionLabel(name, color, zoom) {
            let fontColor = '#FFFFFF';
            if (hoveredRegion != '' && hoveredRegion != name) {
                color = '#FFFFFF';
                fontColor = '#C3AEA2';
            }
            let fontSize = (zoom + 8).toString() + 'px';
            let labelColor = color;
            let html = `<div class="map-region-label" style="background: ${labelColor};">
                            <span style="font-size: ${fontSize}; color: ${fontColor};">${name}</span>
                        </div>`;
            const el = document.createElement('div');
            el.innerHTML = html;
            return el.firstChild;
        }

        map.addLayer(
            {
                id: 'regions-fill-highlighted',
                type: 'fill',
                source: 'composite',
                'source-layer': 'acc_regions',
                paint: {
                    'fill-color': '#D7C9C1'
                },
                filter: ['in', 'name', '']
            },
            'acc-regions-stroke'
        );

        map.addSource('initial-center', {
            type: 'geojson',
            data: {
                type: 'FeatureCollection',
                features: [
                    {
                        type: 'Feature',
                        geometry: {
                            type: 'Point',
                            coordinates: [115, -27]
                        }
                    }
                ]
            }
        });

        map.scrollZoom.disable();
        map.doubleClickZoom.disable();

        let isMobile = false;
        map.on('touchstart', () => {
            isMobile = true;
        });
        let popup;
        const regionsClickEvent = (e) => {
            const regionInfo = regionsLookup[e.features[0].properties.name];
            if (popup) {
                popup.remove();
            }
            popup = new mapboxgl.Popup({ className: 'region-map__overlay-container' })
                .setLngLat([0, 0])
                .setHTML(popupTemplate(regionInfo))
                .addTo(map);
        };

        map.on('click', 'acc-regions', (e) => {
            if (!isMobile) {
                regionsClickEvent(e);
            }
        });

        map.on('mousemove', 'acc-regions', (e) => {
            // Use the first found feature.
            console.log('mousemove');
            const feature = e.features[0];
            if (feature) {
                // Change the cursor style as a UI indicator.
                map.getCanvas().style.cursor = 'pointer';
                let filter = ['!', ['in', ['get', 'name'], feature.properties.name]];
                map.setFilter('regions-fill-highlighted', filter);
            } else {
                map.getCanvas().style.cursor = 'grab';
                map.setFilter('regions-fill-highlighted', ['in', 'name', '']);
            }

            if (hoveredRegion != feature.properties.name) {
                hoveredRegion = feature.properties.name;
                visualiseRegionMarkers();
            }
            if (isMobile) {
                const clonedEvent = { ...e };
                setTimeout(() => {
                    regionsClickEvent(clonedEvent);
                }, 100);
            }
        });

        map.on('mouseleave', 'acc-regions', (e) => {
            if (!e.originalEvent.relatedTarget) {
                map.getCanvas().style.cursor = 'grab';
                map.setFilter('regions-fill-highlighted', ['in', 'name', '']);
                hoveredRegion = '';
                visualiseRegionMarkers();
                if (isMobile && popup) {
                    popup.remove();
                }
            }
        });

        const popupTemplate = (region) =>
            `<div class="region-map__overlay">
                        <div class="region-map__image-holder">
                            <a class="region-map__content-link" target="_blank" href="${region.link}">
                                <img class="region-map__content-image lazyload" src="${region.image}" width="380" height="180"/>
                            </a>
                        </div>

                        <div class="region-map__content-holder">
                            <a class="region-map__content-link" href="${region.link}">
                                <h2 class="region-map__content-title">${region.title}</h2>
                            </a>

                            <p class="region-map__content-description">${region.description}</p>
                            <a class="region-map__content-link region-map__button btn btn-secondary" href="${region.link}">LEARN MORE</a>
                        </div>

                        <div class="region-map__mobile-toggle">
                            <button class="region-map__overlay-toggle" />
                        </div>
                    </div>`;
    });
}

function getUniqueFeatures(features, comparatorProperty) {
    const uniqueIds = new Set();
    const uniqueFeatures = [];
    for (const feature of features) {
        const id = feature.properties[comparatorProperty];
        if (!uniqueIds.has(id)) {
            uniqueIds.add(id);
            uniqueFeatures.push(feature);
        }
    }
    return uniqueFeatures;
}
